import Vue from 'vue'

// 注意 有些组件使用异步加载会有影响
Vue.component('back', () =>
  import ('./back/index.vue'))
Vue.component('table-tooltip', () =>
  import ('./table-tooltip/index.vue'))
Vue.component('d2-table', () =>
  import ('./d2-table/index.vue'))
Vue.component('equity-dialog', () =>
  import ('./equity-dialog/index.vue'))